import script from "./FactoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FactoryPage.vue?vue&type=script&setup=true&lang=js"

import "./FactoryPage.vue?vue&type=style&index=0&id=896ac860&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-896ac860"]])

export default __exports__